<template>
	<ActivityLayout class="comment-activity">
		<template #badge>
			<UserAvatar
				:user="user"
			/>
		</template>
		<template #text>
			<p v-html="translate( `text`, activity )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
		<template #content>
			<div class="content text-markdown" v-html="formattedContent"></div>
		</template>
	</ActivityLayout>
</template>

<script>
import DOMPurify from "dompurify";
import { markdown } from "@teaming/common-util";
import { UserAvatar } from "@teaming/common-ui";
import ActivityLayout from "../Activity/ActivityLayout.vue";

export default {
	name: "GoalCommentActivity",
	components: {
		ActivityLayout,
		UserAvatar,
	},
	props: {
		/** { changedBy:String, changedByPicture:String, comment:String, changedAt:String } */
		activity: {
			type: Object,
			required: true,
		},
		translationNamespace: {
			type: String,
			required: true,
		},
	},
	computed: {
		user() {
			const { changedBy, changedByPicture, } = this.activity;
			return {
				displayName: changedBy,
				picture: changedByPicture,
			};
		},
		formattedContent() {
			const { comment, } = this.activity;
			const renderedComment = markdown.parse( comment || "" );
			return DOMPurify.sanitize( renderedComment );
		},
	},
	methods: {
		// eslint-disable-next-line vue/no-unused-properties
		translate( key, args = {} ) {
			const { translationNamespace, } = this;
			return this.$t( `${ translationNamespace }.${ key }`, args );
		},
	},
};
</script>

<style lang="scss">
$commentTextColor: $color1-700;
$commentBackgroundColor: $color1-050;

.comment-activity .content {
	margin-top: 0.5rem;
	padding: 0.5rem 0.5rem 0.5rem 0.5rem;
	@include font-and-line-for(-1);
	border-radius: 0.5rem;
	background-color: $commentBackgroundColor;

	p {
		color: $commentTextColor;
		text-align: left;
	}
}
</style>
